import { Grid } from '@mui/material';
import React from 'react';
import Color from './shared/Color';
import Slider from './shared/Slider';
import { UpdateFn } from './types';

type Props = {
	primaryColor: string;
	updatePrimaryColor: UpdateFn;
	secondaryColor: string;
	updateSecondaryColor: UpdateFn;
	borderRadius: string;
	updateBorderRadius: UpdateFn;
};

const Buttons = ({
	primaryColor,
	updatePrimaryColor,
	secondaryColor,
	updateSecondaryColor,
	borderRadius,
	updateBorderRadius
}: Props) => (
	<Grid container spacing={2}>
		<Color
			label={intl.tr('styleEditor.buttons.primary')}
			hex={primaryColor}
			disableAlpha
			onChange={updatePrimaryColor}
		/>
		<Color
			label={intl.tr('styleEditor.buttons.secondary')}
			hex={secondaryColor}
			disableAlpha
			onChange={updateSecondaryColor}
		/>
		<Slider
			data-testid="button-radius"
			label={intl.tr('styleEditor.buttons.radius')}
			value={borderRadius}
			onChange={updateBorderRadius}
		/>
	</Grid>
);

export default Buttons;
